import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import localeUtils from 'utils/LanguageLocale';
import CheckoutPromoSection from 'components/RwdCheckout/OrderSummary/CheckoutPromoSection/CheckoutPromoSection';
import { orderDetailsSelector } from 'selectors/order/orderDetails/orderDetailsSelector';
import CheckoutPromoSectionEN from 'components/RwdCheckout/OrderSummary/CheckoutPromoSection/locales/CheckoutPromoSection_en_US.js';
import CheckoutPromoSectionFR from 'components/RwdCheckout/OrderSummary/CheckoutPromoSection/locales/CheckoutPromoSection_fr_CA.js';

const { getTextFromResource, getLocalisedDataFromResource } = localeUtils;

const { wrapHOC } = FrameworkUtils;

const getText = getLocalisedDataFromResource(CheckoutPromoSectionEN, CheckoutPromoSectionFR);

const textResources = createStructuredSelector({
    addPromoOrRewardCodeLabel: getTextFromResource(getText, 'addPromoOrRewardCode'),
    addPromoCodeLabel: getTextFromResource(getText, 'addPromoCode'),
    enterPromoRewardsLabels: getTextFromResource(getText, 'enterPromoRewards')
});

const connectedCheckoutPromo = connect(
    createSelector(orderDetailsSelector, textResources, (orderDetails, { addPromoOrRewardCodeLabel, addPromoCodeLabel, enterPromoRewardsLabels }) => {
        return {
            addPromoOrRewardCodeLabel,
            addPromoCodeLabel,
            enterPromoRewardsLabels,
            appliedPromotions: !Sephora.isDesktop() ? (orderDetails.promotion?.appliedPromotions ?? []) : [],
            items: orderDetails.items?.items
        };
    })
);

const withCheckoutPromoSectionProps = wrapHOC(connectedCheckoutPromo);

export default withCheckoutPromoSectionProps(CheckoutPromoSection);
